import React from 'react';
import './AccoPage.css';

import { Heading, PageTitle, Accommodation } from '../../../components';
import { accommodations } from '../../../constants';



const AccoPage = () => {

  return (

    <>

      {/* Page Title */}
      <PageTitle title={'Accommodations'} page={'Accommodations'} />

      <section className='accommodations'>

        {/* Section heading */}
        <Heading title={'Our Accommodations'} subTitle={'Discover Our Wilderness Lodging'} />

        <div className='box-container'>

          {/* Map over the accommodations array to render each accommodation */}
          {accommodations.map((acco) => { 
            return (
              <Accommodation key={acco.id} acco={acco} />
            );
          })}

        </div>

      </section>

    </>

  )
}

export default AccoPage;